import { isSponsoredAccountAndDimension } from './isSponsoredAccountAndDimension';
import { supportProgrammaticCampaigns } from './supportProgrammaticCampaigns';

export const isOnlySponsored = data => isSponsoredAccountAndDimension(data) && !supportProgrammaticCampaigns(data);
